// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__1+FFp","slideshow":"styles_slideshow__0UYSz"};